import accordion from "./accordion.recipe";
import breadcrumb from "./breadcrumb.recipe";
import checkbox from "./checkbox.recipe";
import dialog from "./dialog.recipe";
import field from "./field.recipe";
import table from "./table.recipe";
import toast from "./toast.recipe";

// Every slot recipe here lists its full anatomy (`xAnatomy.keys()`): extending a default recipe
// replaces its `slots` list rather than merging it, and a slot left out loses all default styles.
export const slotRecipes = {
  accordion,
  table,
  checkbox,
  breadcrumb,
  dialog,
  field,
  toast,
};
